module.exports = __webpack_public_path__ + "static/media/icon_gongan.d0289dc0.jpg";